export const uk = {
    'default-tab-name': 'Стандартні',
    'idea-tab-name': 'Зображення зі сторінки',
    'recently-used-tab-name': 'Раніше використані'
};
